module.exports = __webpack_public_path__ + "img/169.f1bed8b6.jpg";